import * as React from "react";

import { Container, Row, Col } from "react-bootstrap";
import bodhitree_icon from "./assets/Btlogo-final.svg";
import { useMediaQuery } from "react-responsive";
import email_icon from "./assets/email_icon.png";
import trust_edge_footer_logo from "./assets/trust_edge_footer_logo.png";
import phone_icon from "./assets/phone_icon.png";
import FooterTrustItem from "Screens_old/FooterTrustItem/FooterTrustItem";
import trustEdgeStyles from "TrustEdge.module.css";
import { classNames } from "Store/utils";

const FooterTrust = () => {
  const medium = useMediaQuery({ query: "(min-width: 768px)" });
  const phoneNumber = '+918657947489';
  const emailAddress = 'contactus-trustedge@cse.iitb.ac.in';

  const handleEmailClick = (e) => {
    window.location.href = `mailto:${emailAddress}`;
  };

  return medium ? (
    <Container
      fluid
      className={classNames("m-0 p-0", trustEdgeStyles['footer-container'], "d-flex flex-column justify-content-center")}
      style={{ backgroundColor: "#ffffff", borderTop: "1px solid #e9ecef" }}
    >
      <Row md={12} className="m-0 justify-content-start position-relative">
        <Col
          md={12}
          className="my-2 d-flex flex-column justify-content-center align-items-center"
        >
          <div
            className="d-flex align-items-center position-absolute"
            style={{
              cursor: "pointer",
              top: "50%",
              transform: "translateY(-50%)",
              left: "0",
              zIndex: 1,
              height: "80%",
            }}
          >
            <a
              href="https://trustlab.iitb.ac.in/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                height: "60%",
                verticalAlign: "top",
                paddingLeft: "1rem",
              }}
            >
              <img
                className="d-inline-block d-none d-md-block align-top"
                src={trust_edge_footer_logo}
                style={{ width: "85%", height: "100%", filter: "brightness(1.1) contrast(1.1)" }}
                alt="IITB Trust Lab Logo"
              />
            </a>
          </div>
          <div
            className="d-flex align-items-center position-absolute"
            style={{
              cursor: "pointer",
              top: "50%",
              transform: "translateY(-50%)",
              right: "0",
              zIndex: 1,
            }}
          >
            <span 
              className={classNames(trustEdgeStyles["size12"], "ps-3")}
              style={{ 
                color: "#343a40", 
                fontWeight: "600",
                fontSize: "12px"
              }}
            >
              <sub>Powered By</sub>
            </span>
            <img
              className="d-inline-block d-none d-md-block align-top "
              src={bodhitree_icon}
              alt="Bodhitree Logo"
              style={{ 
                width: "50px", 
                height: "50px",
                filter: "brightness(1.1) contrast(1.1)"
              }}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            />
          </div>
          <Row>
            <div className="d-flex justify-content-center w-100 mb-2">
              <FooterTrustItem
                url="/terms"
                childComp={
                  <span 
                    className="footer-text mx-3 px-2"
                    style={{ 
                      color: "#212529", 
                      fontWeight: "600",
                      fontSize: "16px",
                      borderRight: "1px solid #dee2e6",
                      paddingRight: "16px"
                    }}
                  >
                    Terms Of Use
                  </span>
                }
              />
              <FooterTrustItem
                url="/privacy"
                childComp={
                  <span 
                    className="footer-text mx-3 px-2"
                    style={{ 
                      color: "#212529", 
                      fontWeight: "600",
                      fontSize: "16px",
                      borderRight: "1px solid #dee2e6",
                      paddingRight: "16px"
                    }}
                  >
                    Privacy Policy
                  </span>
                }
              />
              <FooterTrustItem
                url="https://docs.google.com/document/d/1kTVJY8_fhmI8pOzuYLL3Kq804DPN0mJNwokuiFq8OD8/edit?tab=t.0"
                openInNewTab={true}
                childComp={
                  <span 
                    className="footer-text mx-3 px-2"
                    style={{ 
                      color: "#212529", 
                      fontWeight: "600",
                      fontSize: "16px"
                    }}
                  >
                    FAQ
                  </span>
                }
              />
            </div>
          </Row>
          <Row>
            <div className={classNames(trustEdgeStyles['size14'], "my-2 d-flex flex-column flex-md-row justify-content-center align-items-center")}>
              <div 
                className="d-flex align-items-center mx-2 px-2 py-1 rounded"
                style={{ backgroundColor: "#f8f9fa", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", border: "1px solid #e9ecef" }}
              >
                <img
                  src={phone_icon}
                  style={{ width: 16, marginRight: 6, filter: "brightness(0.8)" }}
                  alt="phone icon"
                />
                <a
                  className="m-0"
                  style={{ 
                    color: "#343a40", 
                    textDecoration: 'none',
                    fontWeight: "600",
                    fontSize: "14px"
                  }}
                >
                  {phoneNumber}
                </a>
              </div>

              <div 
                className="d-flex align-items-center mx-2 px-2 py-1 rounded"
                style={{ backgroundColor: "#f8f9fa", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", border: "1px solid #e9ecef" }}
              >
                <img
                  src={email_icon}
                  style={{ width: 16, marginRight: 6, filter: "brightness(0.8)" }}
                  alt="email icon"
                />
                <a
                  href={`mailto:${emailAddress}`}
                  onClick={handleEmailClick}
                  className="m-0"
                  style={{ 
                    color: "#343a40", 
                    textDecoration: 'none',
                    fontWeight: "600",
                    fontSize: "14px"
                  }}
                >
                  {emailAddress}
                </a>
              </div>
            </div>
          </Row>
          <Row>
            <div className="d-flex justify-content-center align-items-center mt-1">
              <p
                className="m-0 px-2 py-1 copyright-text"
                style={{ 
                  color: "#6c757d",
                  fontWeight: "500",
                  fontSize: "13px"
                }}
              >
                Copyright @ 2024 Bodhitree, All Rights Reserved
              </p>
            </div>
          </Row>
        </Col>
      </Row>
    </Container>
  ) : (
    <Container 
      fluid 
      className={classNames("m-0 p-0", trustEdgeStyles['footer-container'], "d-flex flex-column")}
      style={{ backgroundColor: "#ffffff", borderTop: "1px solid #e9ecef" }}
    >
      {/* Mobile Header with both logos */}
      <Row md={12} className="m-0 justify-content-between align-items-center py-2">
        <Col xs={6} className="d-flex justify-content-start">
          <a
            href="https://trustlab.iitb.ac.in/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
            }}
          >
            <img
              className="d-inline-block align-top"
              src={trust_edge_footer_logo}
              alt="IITB Trust Lab Logo"
              style={{
                height: "28px",
                width: "auto",
                maxWidth: "120px",
                filter: "brightness(1.1) contrast(1.1)"
              }}
            />
          </a>
        </Col>
        <Col xs={6} className="d-flex justify-content-end align-items-center">
          <span
            className={classNames(trustEdgeStyles["size12"], "me-1")}
            style={{ 
              fontSize: "9px", 
              color: "#343a40",
              fontWeight: "600"
            }}
          >
            Powered By
          </span>
          <img
            className="d-inline-block align-top"
            src={bodhitree_icon}
            alt="Bodhitree Logo"
            style={{
              height: "28px",
              width: "auto",
              maxWidth: "80px",
              filter: "brightness(1.1) contrast(1.1)"
            }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          />
        </Col>
      </Row>

      {/* Navigation Links */}
      <Row md={12} className="m-0 justify-content-start py-2">
        <Col
          xs={12}
          className="d-flex justify-content-start align-items-center flex-wrap"
        >
          <FooterTrustItem
            url="/terms"
            childComp={
              <span 
                className="footer-text px-2 py-1 m-1"
                style={{ 
                  color: "#212529", 
                  fontWeight: "600",
                  fontSize: "14px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "4px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  border: "1px solid #e9ecef",
                  display: "inline-block"
                }}
              >
                Terms Of Use
              </span>
            }
          />
          <FooterTrustItem
            url="/privacy"
            childComp={
              <span 
                className="footer-text px-2 py-1 m-1"
                style={{ 
                  color: "#212529", 
                  fontWeight: "600",
                  fontSize: "14px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "4px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  border: "1px solid #e9ecef",
                  display: "inline-block"
                }}
              >
                Privacy Policy
              </span>
            }
          />
          <FooterTrustItem
            url="https://docs.google.com/document/d/1kTVJY8_fhmI8pOzuYLL3Kq804DPN0mJNwokuiFq8OD8/edit?tab=t.0"
            openInNewTab={true}
            childComp={
              <span 
                className="footer-text px-2 py-1 m-1"
                style={{ 
                  color: "#212529", 
                  fontWeight: "600",
                  fontSize: "14px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "4px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  border: "1px solid #e9ecef",
                  display: "inline-block"
                }}
              >
                FAQ
              </span>
            }
          />
        </Col>
      </Row>

      {/* Contact Information */}
      <Row md={12} className="m-0 justify-content-start py-2">
        <Col xs={12}>
          <div className={classNames(["size12"], "d-flex flex-column justify-content-start align-items-start")}>
            <div 
              className="d-flex align-items-center mx-2 mb-1 px-2 py-1 rounded"
              style={{ 
                backgroundColor: "#f8f9fa", 
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                border: "1px solid #e9ecef",
                width: "fit-content",
                minWidth: "180px"
              }}
            >
              <img
                src={phone_icon}
                style={{ width: "12px", marginRight: "5px", filter: "brightness(0.8)" }}
                alt="Phone"
              />
              <a
                href="tel:+918657947489"
                className="m-0"
                style={{
                  color: "#343a40",
                  textDecoration: "none",
                  fontSize: "11px",
                  fontWeight: "600",
                  wordBreak: "break-word"
                }}
              >
                +91 86579 47489
              </a>
            </div>

            <div 
              className="d-flex align-items-center mx-2 mb-1 px-2 py-1 rounded"
              style={{ 
                backgroundColor: "#f8f9fa", 
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                border: "1px solid #e9ecef",
                width: "fit-content",
                minWidth: "180px"
              }}
            >
              <img
                src={email_icon}
                style={{ width: "12px", marginRight: "5px", filter: "brightness(0.8)" }}
                alt="Email"
              />
              <a
                href="mailto:contactus-trustedge@cse.iitb.ac.in"
                className="m-0"
                style={{
                  color: "#343a40",
                  textDecoration: "none",
                  fontSize: "11px",
                  fontWeight: "600",
                  wordBreak: "break-word",
                  lineHeight: "1.3"
                }}
              >
                contactus-trustedge@cse.iitb.ac.in
              </a>
            </div>
          </div>
        </Col>
      </Row>

      {/* Copyright */}
      <Container
        fluid
        className="d-flex justify-content-start align-items-center"
      >
        <p
          className="m-0 px-2 py-2 copyright-text"
          style={{
            color: "#6c757d",
            fontSize: "11px",
            fontWeight: "500",
            lineHeight: "1.3"
          }}
        >
          Copyright @ 2024 Bodhitree, All Rights Reserved
        </p>
      </Container>
    </Container>
  );
};

export default FooterTrust;